import BaseService from './Base';

class ContactTypes extends BaseService {
  static endpoint = 'api/2.0/contact-types/';
}

export default ContactTypes;